import { ToolTipIcon } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { PageDetectorNames } from 'mockStores/lib/types';
import PageDetectorToggle from './PageDetectorToggle';

const useStyles = createUseStyles({
  container: {
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    padding: '24px',
    position: 'absolute',
  },
  title: {
    composes: 'label3',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: '8px',
  },
});

function PageDetectorToggles(): ReactElement {
  const classes = useStyles();

  function renderPageDetectorToggles() {
    return Object.values(PageDetectorNames).map(pageDetectorName => (
      <PageDetectorToggle key={ pageDetectorName } pageDetectorName={ pageDetectorName } />
    ));
  }

  return (
    <div className={ classes.container }>
      <div className={ classes.title }>
        Page detectors
        <ToolTipIcon
          direction="bottom"
          copy="Enable/disable page detection for one or more page detection types.
        This is persisted in localStorage and defaults to enabled.
        FIND_SAVINGS should be prioritized over the honey checkout autopop.
        Non-SPB checkout types are only available if one of these page types is enabled and detected."
        />
      </div>
      { renderPageDetectorToggles() }
    </div>
  );
}

export default PageDetectorToggles;
